import React from "react";
import { replaceLegacySiteName, useContent } from "../lib/content";
import { controlledTypeStyle } from "../lib/typography";

const FALLBACK_ADDR = ["Berlin · Mitte", "Kleine Präsidentenstraße 4", "10178 Germany"];
const FALLBACK_LINKS = [
  { label: "hello@archdigital.studio", href: "mailto:hello@archdigital.studio" },
  { label: "Instagram ↗", href: "#" },
  { label: "Are.na ↗", href: "#" },
];

function fontSize(value, fallback, min, max) {
  const n = Number(value);
  const safe = Number.isFinite(n) ? Math.min(max, Math.max(min, n)) : fallback;
  return `${safe}px`;
}

export default function Footer() {
  const { content } = useContent();
  const tag1 = content?.footer_tagline_line1 ?? "Let's build";
  const tagItalic = content?.footer_tagline_italic ?? "something";
  const tag2 = content?.footer_tagline_line2 ?? "still.";
  const addrLabel = content?.footer_address_label ?? "⸺ Studio";
  const addrLines = content?.footer_address_lines ?? FALLBACK_ADDR;
  const contactLabel = content?.footer_contact_label ?? "⸺ Contact";
  const links = content?.footer_links ?? FALLBACK_LINKS;
  const legalL = replaceLegacySiteName(
    content?.footer_legal_left ?? "© 2026 Website — All Rights Reserved",
    content
  );
  const legalR = content?.footer_legal_right ?? "Crafted slowly. Rendered carefully.";
  const taglineSize = fontSize(content?.typography_footer_tagline_size, 96, 20, 128);

  return (
    <footer
      data-testid="site-footer"
      className="scroll-effect-section site-section-pad relative border-t border-bone-50/5 py-16"
    >
      <div className="container grid md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-6">
          <div
            className="font-display text-6xl md:text-8xl tracking-tightest leading-[0.85]"
            style={controlledTypeStyle({
              fontSize: taglineSize,
              font: content?.typography_footer_tagline_font,
            })}
          >
            {tag1} <span className="italic text-bone-200/60">{tagItalic}</span>
            <br /> {tag2}
          </div>
        </div>
        <div className="md:col-span-3 space-y-2 font-mono text-xs uppercase tracking-[0.2em] text-bone-200/60">
          <div className="text-bone-200/40">{addrLabel}</div>
          {addrLines.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>
        <div className="md:col-span-3 space-y-2 font-mono text-xs uppercase tracking-[0.2em] text-bone-200/60">
          <div className="text-bone-200/40">{contactLabel}</div>
          {links.map((l, i) => (
            <a
              key={`${l.href}-${i}`}
              href={l.href}
              data-testid={`footer-link-${i}`}
              className="block hover:text-ember transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>
      </div>
      <div className="container mt-16 pt-8 border-t border-bone-50/5 flex flex-col md:flex-row justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-bone-200/40">
        <div data-testid="footer-legal-left">{legalL}</div>
        <div data-testid="footer-legal-right">{legalR}</div>
      </div>
    </footer>
  );
}
